import { render, staticRenderFns } from "./SummaryParityCheck.vue?vue&type=template&id=19b55619"
import script from "./SummaryParityCheck.vue?vue&type=script&lang=js"
export * from "./SummaryParityCheck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports